import { render, staticRenderFns } from "./lnk-lov.vue?vue&type=template&id=6f9a4524&scoped=true&"
import script from "./lnk-lov.vue?vue&type=script&lang=js&"
export * from "./lnk-lov.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9a4524",
  null
  
)

export default component.exports